module.exports = __webpack_public_path__ + "assets/arrow-down.10a06e1d.svg";